
<div class="row form-group">
  <label class="control-label col-2">Thời gian<span class="cred">(*)</span></label>
  <div class="col-2">
    <kendo-dateinput tabindex="1" style="width:138px !important;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.NgayHoc"></kendo-dateinput>
  </div>
  <div class="col-2">
    <kendo-dateinput tabindex="12" style="width:80px;" [format]="'HH:mm'" [(value)]="doituongSelect.NgayHoc"></kendo-dateinput>
  </div>
  <label class="control-label col-2">Đơn vị</label>
  <div class="col-4">
    <ng-select #slChiNhanh 
               class="twcollong"
               [tabIndex]="2"
               [openOnEnter]="false"
               [items]="dschinhanhs"
               [disabled]="true"
               bindValue="Id"
               bindLabel="Ten"
               tabindex="25"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn2"
               (change)="changeChiNhanh($event)"
               [(ngModel)]="doituongSelect.DonViId">
      <ng-template ng-option-tmp let-item="item">
        <div class="rTableRow">
          <div class="rTableCell_1">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>
  <!--<label class="control-label col-1">Lớp</label>
  <div class="col-3">
    <ng-select #slLop
               class="twcollong"
               [tabIndex]="3"
               [disabled]="true"
               [openOnEnter]="false"
               [items]="dslops"
               bindValue="Id"
               bindLabel="Ten"
               tabindex="26"
               notFoundText="Không có dữ liệu"
               [searchFn]="comboSearchFn2"
               [(ngModel)]="doituongSelect.LopId">
      <ng-template ng-option-tmp let-item="item">
        <div class="rTableRow">
          <div class="rTableCell_1">{{item.Ten}}</div>
        </div>
      </ng-template>
    </ng-select>
  </div>-->
</div>

<div class="row form-group">
  <label class="control-label col-2">Tên lớp<span class="cred">(*)</span></label>
  <div class="col-4 in-place">
    <input type="text" tabIndex="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.TenLop">
    <button class="k-icon-modifier" (click)="ChonLopHoc()">Chọn</button>
  </div>
  <div class="col-6">
    <span style="color:blue">
      (Lưu ý: nếu muốn cho học sinh demo theo lớp đã có rồi thì chọn nút CHỌN LỚP, ngược lại thì tạo lớp demo tập trung bằng cách nhập mới vào)
    </span>
  </div>
</div>
 

  <div class="row form-group">

    <label class="control-label col-2 ng-binding">Dạy chính<span class="cred">(*)</span></label>
    <div class="col-4">
      <ng-select #slGiaoVienChinh
                 class="twcollong"
                 [tabIndex]="4"
                 [openOnEnter]="false"
                 [items]="inputGiangViens"
                 bindValue="Id"
                 bindLabel="Ten"
                 notFoundText="Không có dữ liệu"
                 [searchFn]="comboSearchFn"
                 [(ngModel)]="doituongSelect.DayChinhId">
        <ng-template ng-option-tmp let-item="item">

          <div class="rTableRow">
            <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
            <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
    <label class="control-label col-2 ng-binding">Trợ giảng</label>
    <div class="col-4">
      <ng-select #slGiaoVienChinh
                 class="twcollong"
                 [tabIndex]="5"
                 [openOnEnter]="false"
                 [items]="inputGiangViens"
                 bindValue="Id"
                 bindLabel="Ten"
                 placeholder="Trợ giảng"
                 notFoundText="Không có dữ liệu"
                 [searchFn]="comboSearchFn"
                 [(ngModel)]="doituongSelect.TroGiang1Id">
        <ng-template ng-option-tmp let-item="item">

          <div class="rTableRow">
            <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
            <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>


  <div class="row form-group">
    <label class="control-label col-2 ng-binding">Độ tuổi</label>
    <div class="col-4">
      <input type="text" tabIndex="6" class="form-control" placeholder="" [(ngModel)]="doituongSelect.DoTuoi">
    </div>
    <label class="control-label col-2 ng-binding">Người tạo</label>
    <div class="col-4">
      <input type="text" tabIndex="7" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
    </div>

  </div>

  <div class="row form-group">
    <label class="control-label col-2 ng-binding">Ghi chú</label>
    <div class="col-10">
      <textarea type="text" tabIndex="8" rows="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu"></textarea>
    </div>
  </div>

  <div class="row form-group">
    <label class="control-label col-2" style="font-weight:bold">Danh sách học sinh</label>
    <div class="col-10">
      <div class="full-right" style="float:right">
        <button class="btn btn-info btn-add" (click)="ChonHocVien()">{{'Thêm học sinh' | translate}}</button>
        <div style="margin-top:3px">
          <input type="checkbox" style="width:23px;height:23px;padding-right:5px;margin-left:5px;margin-top:2px" [(ngModel)]="TatCa" (click)="TichTatCa()" />
        </div>
        <label class="control-label">Chọn tất cả</label>
      </div>

    </div>
  </div>


  <!-- lưới chi tiết -->
  <div style="padding: 2px 10px 10px 10px;color:black !important; height: calc(100vh - 330px)">
    <div class="row">
      <table class="table table-striped table-bordered table-hover table-condensed">
        <thead [ngClass]="{'theadcss': totalItems>16}">
          <!--<thead>-->
          <tr>
            <th style="min-width:40px;text-align:center;background-color:#f3f8fc">STT</th>
            <th style="min-width:150px;text-align:center;background-color:#f3f8fc">Trạng thái</th>
            <th style="min-width:130px;text-align:center;background-color:#f3f8fc">Tên học sinh</th>
            <th style="min-width:130px;text-align:center;background-color:#f3f8fc">Tên phụ huynh</th>
            <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Số điện thoại</th>
            <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Phụ trách</th>
            <th style="min-width:110px;text-align:center;background-color:#f3f8fc">Điểm danh</th>
            <th style="min-width:110px;text-align:center;background-color:#f3f8fc">Set trạng thái</th>
            <th style="min-width:150px;text-align:left;background-color:#f3f8fc">Nhập ghi chú</th>
            <th style="min-width:90px;text-align:left;background-color:#f3f8fc"></th>


          </tr>

          <tr class="filter-row">
            <td style="text-align:center"></td>
            <td style="text-align:center"></td>
            <td style="text-align:center"></td>
            <td style="text-align:center"></td>
            <td style="text-align:center"></td>
            <td style="text-align:center"></td>
            <td style="text-align:center"></td>
            <td style="text-align:center"></td>
            <td style="text-align:center"></td>
            <td style="text-align:center"></td>


          </tr>

        </thead>
        <tbody style="height:calc(100vh - 370px);">
          <tr *ngFor="let u of doituongSelect.ChiTiets; let i = index">
            <td style="min-width:40px;text-align:center"><a>{{u.STT}}</a></td>
            <td style="min-width:150px">
              <div class="x-grid-cell-inner" style="text-align: center;">
                <a *ngIf="u.TT==1" style="background-color: #000!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #FFFFFF;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==9" style="background-color: #5d7fdd!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==10" style="background-color: #6200ee!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==5" style="background-color: #2cbc63!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==12" style="background-color: #95D03A!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==13" style="background-color: #9d070e!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==2" style="background-color: #570f89!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==4" style="background-color: #b64dff!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==16" style="background-color: #a909bd!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==8" style="background-color: #fa6400!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==3" style="background-color: #e4ff00!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #000;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==7" style="background-color: #00FFFF!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #000;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==14" style="background-color: #dfdfdf!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #000;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==11" style="background-color: #96939b!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==15" style="background-color: #780707ad !important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>
                <a *ngIf="u.TT==6" style="background-color: #FF0000!important;border-radius: 5px;font-size: 12px;padding: 2px 4px;color: #fff;">
                  {{u.TrangThai}}
                </a>



              </div>
            </td>
            <td style="min-width:130px"><a>{{u.HoVaTen}}</a></td>
            <td style="min-width:130px"><a>{{u.TenPhuHuynh}}</a></td>
            <td style="min-width:120px;font-weight:bold"><a>{{u.DienThoaiDiDong}}</a></td>
            <td style="min-width:120px"><a>{{u.PhuTrach}}</a></td>
            <td style="text-align:center;min-width:110px"><input type="checkbox" [(ngModel)]="u.DiemDanh" (ngModelChange)="changeDiemDanh()" /></td>

            <td style="min-width:110px">
              <ng-select [openOnEnter]="false"
                         class="twcollong"
                         id="{{i}}_4"
                         [items]="inputtrangthais"
                         bindValue="Id"
                         bindLabel="Id"
                         tabindex="10"
                         notFoundText="Không có dữ liệu"
                         placeholder=""
                         [searchFn]="comboSearchFn2"
                         (change)="changeTrangThai($event,i)"
                         [(ngModel)]="u.TT">
                <ng-template ng-option-tmp let-item="item">
                  <div class="rTableRow">
                    <div class="rTableCell rTableCell-1">{{item.Id}}</div>
                    <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
                  </div>
                </ng-template>
              </ng-select>

            </td>
            <td style="min-width:150px">
              <input type="text" [(ngModel)]="u.GhiChu" style="width:100%" />
            </td>

            <td style="text-align:center;min-width:90px">
              <a title="Xóa dòng" (click)="deleterow(i)" style="margin-left:5px;cursor:pointer;color:#1e6bb8 !important" class="mb-1 far fa-trash-alt ng2-smart-action ng2-smart-action-custom-custom ng-star-inserted">Xóa dòng</a>
            </td>

          </tr>
        </tbody>
      </table>


    </div>

  </div>







  <div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
    <div>
      <!--<span style="color:red">Tổng số học sinh: {{tong_hv}} (Đi học: {{tong_dihoc}} - Nghỉ học: {{tong_nghihoc}})</span>-->
    </div>
    <div class="">
      <button type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">{{'Ghi lại' | translate}}</button>
      <button class="mb-1 mr-1 btn btn-secondary" (click)="save_chondoituong()" title="Ấn ESC để thoát" style="padding-top:0px !important">Đóng lại</button>
    </div>

  </div>


  <bs-modal #mdChonHocVien class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
    <div class="modal-header">
      <h4 class="modal-title">{{modalTitle}}</h4>
      <button type="button" aria-label="Dismiss" class="close" (click)="mdChonHocVien.close()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <bs-modal-body>
      <app-tonghop-chonhocvientiemnangedit #chonhocvienedit (save)="saveModal($event)"></app-tonghop-chonhocvientiemnangedit>
    </bs-modal-body>
  </bs-modal>

  <bs-modal #mdChonLopHoc class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
    <div class="modal-header">
      <h4 class="modal-title">Chọn lớp học</h4>
      <button type="button" aria-label="Dismiss" class="close" (click)="mdChonLopHoc.close()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <bs-modal-body>
      <app-tonghop-chonlophocedit #chonlophocedit (save)="saveModal_LopHoc($event)"></app-tonghop-chonlophocedit>
    </bs-modal-body>
  </bs-modal>



